<div class="messages-wrapper" #messagesWrapper>
  <app-welcome-message
    class="fade-in-slow"
    [visible]="showWelcomeMessage"
    [welcomeMessage]="welcomeMessage"
    (welcomeClick)="onWelcomeClick($event)"
  ></app-welcome-message>

  <app-message-list
    [messages]="messages"
    [activeMessageId]="activeMessageId"
    [copiedMessageId]="copiedMessageId"
    [exportedMessageId]="exportedMessageId"
    (copySuccess)="onCopySuccess($event)"
    (exportSuccess)="onExportSuccess($event)"
    (exportError)="onExportError($event)"
    (messageEnter)="onMessageEnter($event)"
    (messageLeave)="onMessageLeave()"
    (messageClick)="onMessageClick($event)"
    (messageMouseDown)="onMessageMouseDown($event)"
    (messageMouseUp)="onMessageMouseUp($event)"
    (deleteFile)="onDeleteFile($event)"
  ></app-message-list>
</div>
